var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-field",
    {
      class: {
        "md-has-value": _vm.fixedLabel,
        "md-invalid": _vm.errorMessage,
      },
      attrs: { "md-clearable": _vm.clearable },
    },
    [
      _vm.icon ? _c("md-icon", { class: _vm.icon }) : _vm._e(),
      _vm._v(" "),
      _c("label", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c("md-input", {
        attrs: {
          autocomplete: _vm.autocomplete,
          autofocus: _vm.autofocus,
          disabled: _vm.disabled,
          readonly: _vm.readonly,
          required: _vm.required,
          type: _vm.type,
          value: _vm.value,
        },
        on: {
          input: function ($event) {
            _vm.$emit(
              "input",
              _vm.trim && _vm.type !== "password" && typeof $event === "string"
                ? $event.trim()
                : $event
            )
          },
          change: function ($event) {
            return _vm.$emit("change", $event)
          },
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.$emit("enter")
          },
          keydown: function ($event) {
            return _vm.$emit("keydown", $event)
          },
        },
      }),
      _vm._v(" "),
      _vm.inlineIcon ? _c("md-icon", { class: _vm.inlineIcon }) : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "ui-icon--inline" }, [_vm._t("inlineIcon")], 2),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.flashHintText
          ? _c("span", { staticClass: "md-helper-text" }, [
              _vm._v(_vm._s(_vm.flashHintText)),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.flashHintText && _vm.hint
        ? _c("span", { staticClass: "md-helper-text" }, [
            _vm._v(_vm._s(_vm.hint)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMessage
        ? _c("span", { staticClass: "md-error" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }